<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :gldStCds="item.gldStCds"
            :goldStatusOptions="item.goldStatusOptions" :rcPtys="item.rcPtys" :pypts="item.pypts"
            :isGldPay="item.isGldPay" :isGldLend="item.isGldLend" :pypt="item.pypt" :isGldEx="item.isGldEx"
            :exDayEnd="item.exDayEnd" :exDayStart="item.exDayStart" formType="seller" :fromTypeRouter="item.formType"
            :totalName="item.totalName" :totalProp="item.totalProp" :columnsSource="item.columns" :gldBal="item.gldBal"
            :toBeGldPaid="item.toBeGldPaid" :formSource="item.form" fromPath="circulation/goldcheck"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import goldPage from "@/components/gold-page/gold-page"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    goldPage
  },
  name: "goldcheck",
  data() {
    return {
      tabData: [
        {
          name: "待签收",
          key: "goldcheckPending",
          comp: goldPage,
          gldStCds: "0",
          formType: "5",
          rcPtys: this.$store.getters['home/getUserObj'].cstIds.join(','),
          type: 1,
          columns: ["开立日期", "祺信编号", "开立方", "担保方", "流转方", "祺信面额(元)", "到期日期", "变更状态", "有无发票", "祺信签收转让协议"],
          form: ["开立日期", "祺信编号", "开立方", "流转方", "到期日期", "变更状态"]
        },
        {
          name: "签收记录",
          key: "goldcheckRecord",
          comp: goldPage,
          gldStCds: "1,3,6",
          formType: "5",
          rcPtys: this.$store.getters['home/getUserObj'].cstIds.join(','),
          type: 1,
          columns: ["开立日期", "祺信编号", "开立方", "担保方", "流转方", "祺信面额(元)", "到期日期", "变更状态", "状态", "有无发票", "操作"],
          form: ["开立日期", "祺信编号", "开立方", "流转方", "到期日期", "变更状态", "状态"]
        }
      ],
      tabCur: "goldcheckPending"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/goldcheck.vue